export const KNOWLEDGE_LANGUAGE_KEYS = [
  {
    labelKey: 'Arabic',
    value: 'ar',
  },
  {
    labelKey: 'Armenian',
    value: 'hy',
  },
  {
    labelKey: 'Basque',
    value: 'eu',
  },
  {
    labelKey: 'Bulgarian',
    value: 'bg',
  },
  {
    labelKey: 'Catalan',
    value: 'ca',
  },
  {
    labelKey: 'Chinese Simplified',
    value: 'zh-Hans',
  },
  {
    labelKey: 'Chinese Traditional',
    value: 'zh-Hant',
  },
  {
    labelKey: 'Czech',
    value: 'cs',
  },
  {
    labelKey: 'Danish',
    value: 'da',
  },
  {
    labelKey: 'Dutch',
    value: 'nl',
  },
  {
    labelKey: 'English',
    value: 'en',
  },
  {
    labelKey: 'Finnish',
    value: 'fi',
  },
  {
    labelKey: 'French',
    value: 'fr',
  },
  {
    labelKey: 'Galician',
    value: 'gl',
  },
  {
    labelKey: 'German',
    value: 'de',
  },
  {
    labelKey: 'Greek',
    value: 'el',
  },
  {
    labelKey: 'Hindi',
    value: 'hi',
  },
  {
    labelKey: 'Hungarian',
    value: 'hu',
  },
  {
    labelKey: 'Indonesian (Bahasa)',
    value: 'id',
  },
  {
    labelKey: 'Irish',
    value: 'ga',
  },
  {
    labelKey: 'Italian',
    value: 'it',
  },
  {
    labelKey: 'Japanese',
    value: 'ja',
  },
  {
    labelKey: 'Korean',
    value: 'ko',
  },
  {
    labelKey: 'Latvian',
    value: 'lv',
  },
  {
    labelKey: 'Norwegian',
    value: 'no',
  },
  {
    labelKey: 'Persian',
    value: 'fa',
  },
  {
    labelKey: 'Polish',
    value: 'pl',
  },
  {
    labelKey: 'Portuguese (Brazil)',
    value: 'pt-Br',
  },
];
